// Gesamte Kachel fungiert als Link
let tiles = document.getElementsByClassName('tile');

// if(tiles) {
//     for (let tile of tiles) {
//         let tileLink = tile.querySelector('a');
//         if (tileLink && tileLink.target != "_blank") {
//             tile.addEventListener('click', () => window.location.href = tileLink.href)
//         } else if ((tileLink && tileLink.target == "_blank") ) {
//             tile.addEventListener('click', () =>  window.open(tileLink.href, '_blank').focus() )
//         }
//     }
// }

document.addEventListener('click', function(e) {
    let tile;

    if(e.target.classList.contains('tile')) {
         tile = e.target; 
    } else {
         tile = e.target.closest('.tile')
    }
    if(tile) {
        let tileLink = tile.querySelector('a');
        if(tileLink.target != "_blank") {
        window.location.href = tileLink.href
        } else {
        window.open(tileLink.href, '_blank').focus()
        }
    } 
})

// Zitat-Kachel wird in WP-Content platziert
let zitatTile = document.getElementById('zitat-tile');
let wpContent = document.getElementById('content-with-tile');

if(zitatTile && wpContent) {
    var wpContentChildren = wpContent.children;
    if (wpContentChildren.length >= 5) {
        wpContentChildren.item(3).insertAdjacentElement('afterend', zitatTile);
    } else {
        wpContentChildren.item(2).insertAdjacentElement('afterend', zitatTile);
    }
}

// Extra Padding für Newsletter Image Sibling
let newsletterSection = document.getElementById('newsletter-section');
let documentWidth = document.documentElement.clientWidth

if(newsletterSection && documentWidth >= 1024) {
    let newsletterSibling = newsletterSection.previousElementSibling;
    if (newsletterSibling.nodeName == "SECTION") {
        newsletterSibling.style.paddingBottom = '2rem'
    }   
}